import { SortByFn } from "react-table";

import cronExpressionToDayjs from "@/helpers/cronExpressionToDayjs";

import { DataSource } from "./columns";

const getCronExpressionValue = (row: DataSource, desc?: boolean) => {
  const maxMinSortValue = desc
    ? Number.MIN_SAFE_INTEGER
    : Number.MAX_SAFE_INTEGER;

  if (row.status === "NOT_STARTED" || row.status === "PAUSED") {
    return maxMinSortValue;
  }
  if (row.orchestrationWorkflow?.id) {
    return cronExpressionToDayjs(
      row.orchestrationWorkflow.cronExpression,
    ).unix();
  }
  if (row.syncInterval) {
    return cronExpressionToDayjs(row.syncInterval).unix();
  }
  return maxMinSortValue;
};

export const cronExprSortFn: SortByFn<DataSource> = (
  rowA,
  rowB,
  columnId,
  desc,
) => {
  return (
    getCronExpressionValue(rowA.original, desc) -
    getCronExpressionValue(rowB.original, desc)
  );
};
